module.exports = __webpack_public_path__ + "static/img/filing.f7d1deed.jpg";